function textPageInit($context) {
    //галерея
    var $gallery = $(".gallery", $context);

    if ($gallery.length) {
        $gallery.lightGallery({
            selector: ".gallery__item",
            download: false
        });
    }

    //базовый слайдер
    var $sliderBase = $(".js-slider--base", $context);

    if ($sliderBase.length) {
        $sliderBase.lightSlider({
            gallery: false,
            item: 1,
            slideMargin: 0,
            controls: true,
            pager: false,
            onSliderLoad: function (el) {
                var count = el.getTotalSlideCount();
                $(el).parent().append('<div class="slider__counter">\n' +
                    '<span class="slider__counter_item slider__counter_item--current">1</span>\n' +
                    '<span class="slider__counter_item slider__counter_item--total">' + count + '</span></div>');
            },
            onBeforeSlide: function (el) {
                $(el).parent().find('.slider__counter_item--current').text(el.getCurrentSlideCount());
            }
        });
    }

    //обертка таблиц
    var $textTables = $(".text table", $context);

    if ($textTables.length) {
        $textTables.each(function () {
            $(this).wrap('<div class="table_wrap">');
        });
    }
}

$(document).ready(function () {

    //кнопки с триггером на 2 иконки
    var $triggerBtn = $(".js-trigger_btn");

    if ($triggerBtn.length) {
        $triggerBtn.on("click", function (e) {
            $(this).toggleClass("js-trigger_btn--active");
        });
    }

    window.mobilecheck = function () {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    //фоновое видео
    var bgVideo = document.querySelector('.js-index-bg-video');
    if (bgVideo && !mobilecheck()) {
        var preloaderListeners = {
            'bgVideo': false,
            'promoVideo': false
        }, preloaderCallbacks = [];

        function hidePreloader(key, cb) {
            preloaderListeners[key] = true;
            if (cb) {
                preloaderCallbacks.push(cb);
            }
            if (Object.values(preloaderListeners).filter(function (item) {
                return !item;
            }).length === 0) {
                $(".preloader").addClass("preloader--hidden");
                preloaderCallbacks.forEach(function (item) {
                    item();
                });
                preloaderCallbacks = [];
            }
        }

        bgVideo.addEventListener('error', function () {
            hidePreloader('bgVideo');
        });
        bgVideo.src = "/build/video/video_bg.mp4";
        bgVideo.muted = true;
        bgVideo.pause();
        if (bgVideo.readyState > 3) {
            hidePreloader('bgVideo');
        } else {
            bgVideo.addEventListener('canplaythrough', function () {
                hidePreloader('bgVideo');
            }, false);
        }

        var promoVideo = document.querySelector('.promo_movie__video');
        if (promoVideo) {
            promoVideo.src = "/build/video/video_full.mp4";
            promoVideo.pause();

            function playPausePromo() {
                if (promoVideo.paused) {
                    $('.js-video-play').hide();
                    promoVideo.play().catch(function () {
                        $('.js-video-play').show();
                    });
                } else {
                    promoVideo.pause();
                    $('.js-video-play').show();
                }
            }

            function runPromo() {
                if (promoVideo.paused) {
                    $('.js-video-play').show();
                    promoVideo
                        .play()
                        .then(function () {
                            $('.js-video-play').hide();
                        })
                        .catch(function (err) {
                            if (err.name === "NotAllowedError") {
                                setTimeout(function () {
                                    runPromo();
                                }, 500)
                            } else {
                                console.error(err);
                                $('.promo_movie__control--close').click();
                            }
                        });
                }
            }

            $('.promo_movie__control--sound').on('click', function () {
                promoVideo.muted = !promoVideo.muted;
            });
            $('.js-video-play').on('click', playPausePromo);
            $('.promo_movie').on('click', function (e) {
                if (e.target.classList.contains('promo_movie')) {
                    playPausePromo();
                }
            });
            window.addEventListener('keyup', playPausePromo);


            if (promoVideo.readyState > 3) {
                hidePreloader('promoVideo', runPromo);
            } else {
                promoVideo.addEventListener('canplaythrough', function () {
                    hidePreloader('promoVideo', runPromo);
                }, false);
                promoVideo.addEventListener('ended', function () {
                    $('.promo_movie__control--close').click();
                });
            }
            $('.promo_movie__control--close').on('click', function (e) {
                window.removeEventListener('keyup', playPausePromo);
                promoVideo.pause();
                promoVideo.muted = true;
                bgVideo.play();
                e.stopPropagation();
            })
        } else {
            hidePreloader('promoVideo', function () {
                setTimeout(function () {
                    $('.presentation').hide();
                }, 1500);
                bgVideo.play();
            });
        }
    } else {
        $(".preloader").addClass("preloader--hidden");
        setTimeout(function () {
            $('.presentation').hide();
        }, 1500);
    }

    //универсальный fadeIn
    $(".js-fadein__btn").on("click", function (e) {
        e.preventDefault();
        var name = $(this).attr("data-fadeIn");
        var speed = $(this).attr("data-fadeIn-speed");
        if (name) {
            var content = $(".js-fadein__content[data-fadeIn=" + name + "]");
            content.fadeIn(parseInt(speed) || 200);
        }
    });

    //универсальный fadeOut
    $(".js-fadeout__btn").on("click", function (e) {
        e.preventDefault();
        var name = $(this).attr("data-fadeOut");
        var speed = $(this).attr("data-fadeOut-speed");
        if (name) {
            var content = $(".js-fadeout__content[data-fadeOut=" + name + "]");
            content.fadeOut(parseInt(speed) || 200);
        }
    });

    //поля форм с подсказками
    if ($(".js-form_group").length) {

        var $inputs = $("input", ".js-form_group");
        var $textareas = $("textarea", ".js-form_group");
        var $selects = $("select", ".js-form_group");

        var fn = function () {
            if ($(this).val().trim() !== "") {
                $(this).closest(".form__group").addClass("form__group--filled");
            }

            $(this).on("focus", function () {
                $(this).closest(".form__group").addClass("form__group--filled");
            });

            $(this).on("blur", function () {
                if ($(this).val().trim() === "")
                    $(this).closest(".form__group").removeClass("form__group--filled");
            });
        };

        $inputs.each(fn);
        $textareas.each(fn);
        $selects.each(fn);
    }

    textPageInit($(document.body));

    var forms = document.querySelectorAll('.js-form');
    if (forms.length > 0) {
        forms.forEach(function (el) {
            var form = new TurboForm(el, {
                errorClass: 'form__group--error',
                fieldLineClass: 'form__group',
                errorMsgClass: 'form__error_msg',
                showErrorAfterInput: true
            });

            var $submitButton = $('.js-target-form[data-form=' + form.form.getAttribute('name') + ']');
            if ($submitButton.length) {
                $submitButton.on('click', function (e) {
                    e.preventDefault();
                    form.onSubmit();
                    if (window.hasOwnProperty('ym')) {
                        var name = el.getAttribute('name');
                        if (name === 'catering') {
                            window.ym(52695778, 'reachGoal', 'otpravit_keitering');
                        }
                        if (name === 'reserve') {
                            window.ym(52695778, 'reachGoal', 'otpravit_rezerv_stolov');
                        }
                    }
                })
            }

            form.showPreloader = function () {
                if (this.preloader) {
                    this.preloader.classList.add('loader--visible');
                }
            };

            form.hidePreloader = function () {
                if (this.preloader) {
                    this.preloader.classList.remove('loader--visible');
                }
            };

            if (form.form.attributes.name.value === 'confirm-phone') {
                form.showSuccessMessage = function (msg) {
                    $(this.form).slideUp();
                    $('.js-step-two').slideDown();
                };
            } else if (form.form.attributes.name.value === 'check-code') {
                form.showSuccessMessage = function (msg) {
                    window.location = msg;
                };
            } else if (form.form.attributes.name.value === 'bonus-check-code') {
                form.showSuccessMessage = function (msg) {
                    $(this.form).slideUp();
                    $('.js-bonus-check-step-3').html(msg).slideDown();
                };
            } else {
                form.showSuccessMessage = function (msg) {
                    $(this.form).slideUp();
                    $('.js-success-message__' + this.form.getAttribute('name')).html(msg);
                    $('.js-hide-after-success__' + this.form.getAttribute('name')).hide();
                    $('.js-show-after-success__' + this.form.getAttribute('name')).show();
                    $submitButton.hide();
                };
            }

            form.showErrorForInput = function (container, input, filedName) {
                TurboForm.prototype.showErrorForInput.apply(this, [container, input, filedName]);
                container.classList.add('form__group--error');
            };

            form.hideOldErrors = function () {
                TurboForm.prototype.hideOldErrors.apply(this);
                var items = this.form.querySelectorAll('.form__group--error');
                if (items.length) {
                    items.forEach(function (field) {
                        field.classList.remove('form__group--error');
                    });
                }
            };

        });

    }

    function lazyLoad(target, imageLocation) {
        var bgImg = new Image();
        bgImg.onload = function () {
            target.style.backgroundImage = 'url(' + bgImg.src + ')';
        };
        bgImg.src = imageLocation;
    }

    var portraitLoad = false, normalLoad = false;

    if (window.innerWidth < window.innerHeight) {
        $('.js-bg-lazy-portrait').map(function () {
            lazyLoad(this, this.dataset.original);
            portraitLoad = true;
        });
        window.addEventListener('resize', function () {
            if (!normalLoad) {
                $('.js-bg-lazy').map(function () {
                    lazyLoad(this, this.dataset.original);
                });
            }
        });
    } else {
        $('.js-bg-lazy').map(function () {
            lazyLoad(this, this.dataset.original);
            normalLoad = true;
        });
        window.addEventListener('resize', function () {
            if (!portraitLoad) {
                $('.js-bg-lazy-portrait').map(function () {
                    lazyLoad(this, this.dataset.original);
                });
            }
        });
    }
});


